import React from "react";

import Modal from 'react-bootstrap/Modal'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import Spinner from './Spinner';

// Full-screen loading modal for suspense fallback and route transitions.
const Loader = props => {
	return (
		<Modal
			show={true}
			aria-labelledby="contained-modal-loader"
			centered
			backdrop="static"
			size="sm"
			keyboard={false}
			animation={false}
			className="loader-modal"
		>
			<Row className="justify-content-center mb-1">
				<Col xs={"auto"}>
					<Spinner />
				</Col>
			</Row>
		</Modal>
	);
};

export default Loader;
